/* eslint-disable no-irregular-whitespace */
import React, { memo, useCallback, useEffect, useMemo } from 'react';
import { emitAnalyticEvent } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';
import { BaseConfirmDialog } from 'reactApp/components/BaseConfirmDialog/BaseConfirmDialog';
import { EButtonType } from 'reactApp/components/BaseConfirmDialog/BaseConformationDialog.types';
import { type VK_MUSIC_BUNDLE_SOURCE, VK_MUSIC_RADAR_NAMES } from 'reactApp/modules/vkMusic/vkMusic.const';
import { ECategoryGa, sendPaymentGa } from 'reactApp/utils/paymentGa';

export interface VkMusicAnonymousConfirmModalProps {
    onClose?: () => void;
    onClick?: () => void;
    onShow?: () => void;
    onCancel?: () => void;
    source: VK_MUSIC_BUNDLE_SOURCE;
}

export const VkMusicAnonymousConfirmModal = memo<VkMusicAnonymousConfirmModalProps>(({ onClose, onClick, onShow, onCancel, source }) => {
    const sendAnalytics = useCallback((action: string, restArgs = {}) => {
        sendPaymentGa({
            action,
            name: `${VK_MUSIC_RADAR_NAMES.CONFIRM_MODAL}-anon`,
            eventCategory: ECategoryGa.modal,
            offer_source: source,
            ...restArgs,
        });
    }, []);

    useEffect(() => {
        sendAnalytics('show');
        emitAnalyticEvent(AnalyticEventNames.VK_MUSIC_CONFIRM_SHOW, { source });
        onShow?.();
    }, []);

    const handleOnClick = useCallback(() => {
        sendAnalytics('click', { button_name: 'continue' });
        emitAnalyticEvent(AnalyticEventNames.VK_MUSIC_CONFIRM_CONTINUE, { source });
        onClick?.();
        onClose?.();
    }, []);

    const handleOnCancel = useCallback(() => {
        sendAnalytics('close');
        emitAnalyticEvent(AnalyticEventNames.VK_MUSIC_CONFIRM_CLOSE, { source });
        onCancel?.();
        onClose?.();
    }, []);

    const renderHeader = useCallback(() => <>Выберите аккаунт VK ID</>, []);
    const renderContent = useCallback(() => <>Для него подключим подписку Mail Space + VK Музыка</>, []);
    const buttons = useMemo(() => [EButtonType.accept], []);

    return (
        <BaseConfirmDialog
            renderHeader={renderHeader}
            successButtonText="Выбрать VK ID"
            buttons={buttons}
            onClose={handleOnCancel}
            onSuccess={handleOnClick}
            renderContent={renderContent}
            closable
        />
    );
});

VkMusicAnonymousConfirmModal.displayName = 'VkMusicAnonymousConfirmModal';
